import React from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { InternalAxiosRequestConfig } from "axios";
import Api from "../../config/ApiConfig";
import { ApiAdminScope, ApiUserScope } from "../../config/AuthConfig";
import { useDispatch, useSelector } from "react-redux";
import { SetAccessToken, SetTokenClaims } from '../../store/auth/actions';
import jwt, { JwtPayload } from "jwt-decode";
import { getRoleClaimsSelector } from "../../store/auth/selectors";

interface RequestInterceptorProps {
    children: React.ReactNode,
}

const RequestInterceptor = (props: RequestInterceptorProps) => {

    const { children } = props;
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);
    const dispatch = useDispatch();
    const role: string[] = useSelector(getRoleClaimsSelector);
    
    Api.interceptors.request.use(async (axiosConfig: InternalAxiosRequestConfig<any>) => {
        if (!account) {
            throw Error('No active account! Verify a user has been signed in.');
        }
        
        // using roles 
        // if you are admin - IDP.Admin or IDP.User
        // ApiAdminScope
        // else 
        // ApiUserScope
        
        let scope = role.includes("IDP.Admin") ? ApiAdminScope : ApiUserScope;

        // ApiScope - use this to generate access token for api
        const response = await instance.acquireTokenSilent({
            ...scope, 
            account,
        });

        const token = response.accessToken;
        
        if (token) {
            dispatch(SetAccessToken(token));
            var decodeTokenClaims = jwt<JwtPayload>(token);
            dispatch(SetTokenClaims(decodeTokenClaims));

        }

        const bearer = `Bearer ${token}`;

        if (axiosConfig && axiosConfig.headers) {
            axiosConfig.headers.Authorization = bearer;
        }
        return axiosConfig;
    });


    return (
        <>
            {children}
        </>
    );
};

export default RequestInterceptor;

